import {AgreementContainer} from '../containers/Documents/AgreementContainer'

export const Agreement = () => (
    <>
        <AgreementContainer />
    </>
)